<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
    <div
      v-show="this.$store.state.layout === 'landing'"
      class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
    ></div>
    <sidenav
      :custom_class="this.$store.state.mcolor"
      :class="[
        this.$store.state.isTransparent,
        this.$store.state.isRTL ? 'fixed-end' : 'fixed-start'
      ]"
      v-if="this.$store.state.showSidenav"
    />
    <main
      class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
    >
      <!-- nav -->
      <navbar
        :class="[navClasses]"
        :textWhite="
          this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
        "
        :minNav="navbarMinimize"
        v-if="this.$store.state.showNavbar"
      />
      <router-view />
      <app-footer v-show="this.$store.state.showFooter" />
      <configurator
        :toggle="toggleConfigurator"
        :class="[
          this.$store.state.showConfig ? 'show' : '',
          this.$store.state.hideConfigButton ? 'd-none' : ''
        ]"
      />
    </main>
  </template>
  <script>
  import Sidenav from "../../src/examples/Sidenav";
  import Configurator from "@/examples/Configurator.vue";
  import Navbar from "@/examples/Navbars/Navbar.vue";
  import AppFooter from "@/examples/Footer.vue";
  import { mapMutations } from "vuex";
  
  export default {
    name: "App",
    components: {
      Sidenav,
      Configurator,
      Navbar,
      AppFooter
    },
    methods: {
      ...mapMutations(["toggleConfigurator", "navbarMinimize"])
    },
    computed: {
      navClasses() {
        return {
          "position-sticky bg-white left-auto top-2 z-index-sticky":
            this.$store.state.isNavFixed && !this.$store.state.darkMode,
          "position-sticky bg-default left-auto top-2 z-index-sticky":
            this.$store.state.isNavFixed && this.$store.state.darkMode,
          "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
            .isAbsolute,
          "px-0 mx-4": !this.$store.state.isAbsolute
        };
      }
    },
    beforeMount() {
      this.$store.state.isTransparent = "bg-transparent";
    }
  };
  </script>
  <style scoped>
  .top {
    height: 40vh;
    z-index: 0;
    background: linear-gradient(#21a90f, #006730);
  }

  .content {
    z-index: -1;
    background: linear-gradient(#c0c0c0, #ffffff);
  }

  #sidenav-main {
    border: 1px solid black !important;
  }
</style>
<style>
.card {
  border: 1px solid black !important;
}

.div_tabela {
  height: 77.5vh;
}

.btn_pen {
  background-color: #567eff;
  padding: 2px 10px;
  border-radius: 5px;
  border: 1px solid #333131;
}

.btn_pen:hover {
  background-color: #405ec0;
  transition-duration: 0.2s;
}

.btn_delete {
  background-color: #fd4d4d;
  padding: 2px 10px;
  border-radius: 5px;
  border: 1px solid #333131;
  margin-left: 10px;
}

.btn_delete:hover {
  background-color: #cc3d3d;
  transition-duration: 0.2s;
}

.btn_busca {
  background-color: #fff;
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid #c3c3c3;
}

.btn_busca:hover {
  background-color: #c0c0c0;
  border: 1px solid #333131;
  transition-duration: 0.2s;
}

.btn_add {
  background-color: #fff;
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid #c3c3c3;
}

.btn_add:hover {
  background-color: #c0c0c0;
  border: 1px solid #333131;
  transition-duration: 0.2s;
}

#logo {
  width: 100%;
}

@media (min-width: 992px) and (max-width: 1200px) {
  #sidenav-main {
    max-width: 15em !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #sidenav-main {
    max-width: 14em !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {}

@media (max-width: 575px) {}

</style>